import React, { ChangeEventHandler, useEffect, useMemo } from 'react';
import theme from './ExportColumnSelection.module.scss';
import { ExportColumnDefinition } from '@/services/order-export';
import { Checkbox } from '@ygtechnologies/rubus-ui';
import { Trans } from '@lingui/react/macro';
import { toggleValue } from '@ygtechnologies/rubus-frontend-utilities';

export interface ExportColumnSelectionProps {
    columns: ExportColumnDefinition[];
    value: string[];
    onChange(newValue: string[]): void;
}

export const ExportColumnSelection: React.FC<ExportColumnSelectionProps> = ({ columns, value, onChange }) => {
    const mandatoryColumns = columns.filter((x) => x.isMandatory);

    const fixedValue = useMemo(() => {
        return value.filter((x) => columns.find((col) => col.key === x));
    }, [value]);

    const handleColumnChange: ChangeEventHandler<HTMLInputElement> = (e) => {
        onChange(toggleValue(fixedValue, e.target.name, e.target.checked));
    };
    const handleSelectAll: ChangeEventHandler<HTMLInputElement> = (e) => {
        if (e.target.checked) {
            onChange(columns!.map((x) => x.key));
        } else {
            onChange(mandatoryColumns.map((x) => x.key));
        }
    };

    return (
        <div>
            <div>
                <Checkbox
                    indeterminate={fixedValue.length > mandatoryColumns.length && fixedValue.length < columns.length}
                    checked={fixedValue.length === columns.length}
                    onChange={handleSelectAll}>
                    <Trans>Select all</Trans>
                </Checkbox>
            </div>

            <ul>
                {columns.map((c) => (
                    <li key={c.key}>
                        <Checkbox
                            disabled={c.isMandatory}
                            checked={value.includes(c.key)}
                            name={c.key}
                            onChange={handleColumnChange}>
                            {c.name}
                        </Checkbox>
                    </li>
                ))}
            </ul>
        </div>
    );
};
